import { useSelector } from 'react-redux';
import { MembershipLevels, ScoreGrade, User } from '../shared/typesTS';
import useIntersectionObserver from './useIntersectionObserver';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import create from 'zustand';
import useLocalStorage from 'hooks/useLocalStorage';
import useMediaQuery from './useMediaQuery';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';

export const useFundingSearchDriverStore = create((set) => ({
  creditScore: undefined,
  setCreditScore: (value) => set(() => ({ creditScore: value })),
}));

export enum FundingSearchDriverPosition {
  HEADER,
  PROFILE_HEADER,
  CREDIT_SCORE,
}

export const useIsFundingSearchPage = (): boolean => {
  const { pathname } = useLocation();
  return pathname.includes('business/funding/search');
};

const useDisplayFundingSearchDriver = ({
  position,
  ref,
  creditScore,
}: {
  position: FundingSearchDriverPosition;
  ref: any;
  creditScore?: ScoreGrade | undefined;
}): { visible: boolean; removeBanner: () => void; creditScore: ScoreGrade | undefined } => {
  const creditScoreStored = useFundingSearchDriverStore((state) => state.creditScore);
  const setCreditScore = useFundingSearchDriverStore((state) => state.setCreditScore);
  const [visible, setVisible] = useLocalStorage('capitalise/funding-search-driver', true);
  const isFundingSearchPage = useIsFundingSearchPage();
  //@ts-ignore <- for the immutable state
  const userImmutable = useSelector((state) => state.getIn(['me', 'user']));
  const user: User = !!userImmutable && userImmutable.toJS();
  const { isMobile } = useMediaQuery();
  const isFree =
    user?.membership?.level &&
    (user?.membership?.level?.name === MembershipLevels.free ||
      user?.membership?.level?.name === MembershipLevels.freeZA);

  const isDriverActive =
    isFundingSearchPage &&
    isFree &&
    position === FundingSearchDriverPosition.PROFILE_HEADER &&
    !!visible &&
    !isMobile;
  const isHeaderVisible = isFundingSearchPage && isFree && !!visible && isMobile;

  const removeBanner = () => {
    Analytics.track(AnalyticsEventCategory.profile, AnalyticsEventAction.applicationDriverDismiss);
    setVisible(false);
  };

  useEffect(() => {
    if (creditScore) {
      setCreditScore(creditScore);
    }
  }, [creditScore]);

  if (position === FundingSearchDriverPosition.HEADER) {
    return {
      visible: isHeaderVisible,
      removeBanner,
      creditScore: creditScoreStored ?? creditScore,
    };
  }

  return { visible: isDriverActive, removeBanner, creditScore: creditScoreStored ?? creditScore };
};

export default useDisplayFundingSearchDriver;
